import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

/** Stesso look del FAB sulla Home marketing (scroll su `window`). */
const ScrollFab = styled(Button)(() => ({
  position: 'fixed',
  bottom: 20,
  right: 20,
  minWidth: 50,
  width: 50,
  height: 50,
  borderRadius: '50%',
  padding: 0,
  backgroundColor: 'rgb(30, 237, 159)',
  color: '#000',
  boxShadow: '0 4px 12px rgba(30, 237, 159, 0.4)',
  zIndex: 99999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '1px solid rgba(255, 255, 255, 0.35)',
  '&:hover': {
    backgroundColor: 'rgb(25, 200, 130)',
    boxShadow: '0 6px 16px rgba(30, 237, 159, 0.6)',
    transform: 'translateY(-2px)',
  },
  transition: 'all 0.3s ease',
}));

export interface PublicScrollToTopFabProps {
  /** es. "Torna su" / "Back to top" per locale blog */
  ariaLabel: string;
}

export const PublicScrollToTopFab: React.FC<PublicScrollToTopFabProps> = ({
  ariaLabel,
}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY ?? document.documentElement.scrollTop;
      setVisible(y > 300);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <ScrollFab
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label={ariaLabel}
      disableElevation
    >
      <KeyboardArrowUpIcon />
    </ScrollFab>
  );
};
